import { render } from "./Balance.vue?vue&type=template&id=06802e41&scoped=true"
import script from "./Balance.vue?vue&type=script&lang=js"
export * from "./Balance.vue?vue&type=script&lang=js"

import "./Balance.vue?vue&type=style&index=0&id=06802e41&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06802e41"]])

export default __exports__